"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserInfo = UserInfo;
const React = __importStar(require("react"));
const Elements = __importStar(require("@genesys/client-core/lib/elements"));
const LanguageTexts = __importStar(require("@genesys/shared/lib/language-texts"));
const oidc_client_ts_1 = require("oidc-client-ts");
const client_config_1 = require("../../../../client-config");
function UserInfo({ userName, textTranslator }) {
    return (React.createElement(Elements.UserInfo, null,
        React.createElement(Elements.GenesysLogo, { src: "/assets/images/munterslogo2.png" }),
        React.createElement("div", null,
            React.createElement(Elements.UserLoginInfoTable, null,
                React.createElement("tbody", null,
                    React.createElement("tr", null,
                        React.createElement("td", null,
                            textTranslator(LanguageTexts.loggedinuser()),
                            ":"),
                        React.createElement("td", null, userName))))),
        React.createElement("div", null,
            React.createElement("a", { onClick: async () => {
                    const manager = new oidc_client_ts_1.UserManager({
                        authority: client_config_1.config.oidcAuthority,
                        client_id: client_config_1.config.oidcClientId,
                        redirect_uri: client_config_1.config.oidcRedirectUri,
                        post_logout_redirect_uri: window.location.origin,
                        response_type: client_config_1.config.oidcResponseType,
                        scope: client_config_1.config.oidcScope,
                        monitorSession: false,
                        loadUserInfo: false
                    });
                    await manager.signoutRedirect();
                } }, textTranslator(LanguageTexts.logout())))));
}
//# sourceMappingURL=user-info.js.map